import { render } from "./UserDashboard.vue?vue&type=template&id=fb47ee22&ts=true"
import script from "./UserDashboard.vue?vue&type=script&lang=ts"
export * from "./UserDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__